import React, {Component} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ScrollableAnchor from 'react-scrollable-anchor';
import demoScreen from '../assets/img/browser-connection.png';
import CustomButton from '../common/CustomButton';

class NewPartnerComp extends Component {
  render() {
    return (
      <ScrollableAnchor id={'newPartner'}>
        <Container className="container-full new-partner-container">
          <Row>
            <Col xs={12} className="flex-col">
              <div className="new-partner-title">Espace pro</div>
            </Col>
            <Col xs={12} md={7} className="left-screen">
              <div className="new-partner-subtitle">Enseigne, Franchise, Commercant, soyons partenaires dès à présent !</div>
              <div className="new-partner-text">
                Optimisez votre business en misant sur les tickets de caisse et factures dématérialisés avec CleanBill.
              </div>
              <Link to={'/become_partner'}>
                <CustomButton text={'Demande d\'information'} />
              </Link>
            </Col>
            <Col xs={12} md={5} className="partner-comp-right-screen">
              <img src={demoScreen} alt="demo-screen" className="demo-screen" />
            </Col>
          </Row>
        </Container>
      </ScrollableAnchor>
    );
  }
}

export default NewPartnerComp;
